// components/RegionAutoComplete.jsx

import { getSeniorExecutiveAutoComplete } from "app/services/RegionService";
import AsyncSelect from "react-select/async";

function SeniorExecutiveAutocomplete({
  value,
  onChange,
  placeholder = "Senior Executive",
  isDisabled = false,
  name = "region",
}) {
  // load options only when typing
  const loadOptions = async (inputValue) => {
    try {
      // prevent api call on refresh/open
      if (!inputValue || inputValue.trim().length < 1) {
        return [];
      }
      debugger;
      const response = await getSeniorExecutiveAutoComplete(inputValue);

      const options = (response?.data || []).map((item) => ({
        id: item.id,
        label: item.name,
        regionId: item.regionId,
      }));

      return options;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions={false}
      defaultOptions={false} // prevent auto api call
      value={value}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable
      noOptionsMessage={({ inputValue }) =>
        !inputValue
          ? "Type to search senior executive"
          : "No area senior executive found"
      }
      loadingMessage={() => "Searching..."}
    />
  );
}

export default SeniorExecutiveAutocomplete;
